import { queryOptions, useQuery } from "@tanstack/react-query";

import { useGitpodAPI } from "@/hooks/use-gitpod-api";
import { useOrganization } from "@/queries/organization-queries";
import { keyWithPrincipal } from "@/queries/principal-key";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

const enterpriseBillingKeys = {
    info: (organizationId: string) => keyWithPrincipal(["enterprise-billing", "info", organizationId]),
};

export function useGetEnterpriseBillingInfoOptions() {
    const api = useGitpodAPI();
    const { data: organization } = useOrganization();
    const organizationId = organization?.id ?? "";
    const isEnterprise = organization?.tier === OrganizationTier.ENTERPRISE;

    return queryOptions({
        queryKey: enterpriseBillingKeys.info(organizationId),
        queryFn: async () => {
            const response = await api.billingService.getEnterpriseBillingInfo({
                organizationId,
            });
            return response;
        },
        enabled: !!organizationId && isEnterprise,
    });
}

export function useGetEnterpriseBillingInfo() {
    return useQuery(useGetEnterpriseBillingInfoOptions());
}
